
import { defineComponent, PropType } from 'vue'
import { iDimensionField, iDimensionMetadata } from '../../../HierarchyManagement'
import Dropdown from 'primevue/dropdown'
import Listbox from 'primevue/listbox'

export default defineComponent({
    name: 'hierarchy-management-hierarchy-master-select-list',
    components: {
        Dropdown,
        Listbox
    },
    props: { dimensionMetadata: { type: Object as PropType<iDimensionMetadata | null> } },
    emits: ['recursiveChanged', 'levelsChanged'],
    data() {
        return {
            dimensionSourceFields: [] as iDimensionField[],
            selectedSourceFields: [] as iDimensionField[],
            dimensionDestinationFields: [] as any[],
            selectedDestinationFields: [] as any[],
            errorMessageVisible: false,
            recursive: null as any,
            parentDimensionSourceFields: [] as iDimensionField[],
            recursiveParentName: null as any,
            recursiveParentDescription: null as any
        }
    },
    watch: {
        dimensionMetadata() {
            this.loadDimensionData()
        }
    },
    created() {
        this.loadDimensionData()
    },
    methods: {
        loadDimensionData() {
            this.dimensionSourceFields = []
            this.parentDimensionSourceFields = []
            this.dimensionMetadata?.DIM_FIELDS.forEach((filter: iDimensionField) => (filter.PARENT ? this.parentDimensionSourceFields.push(filter) : this.dimensionSourceFields.push(filter)))
        },
        onSelectedField() {
            if (this.selectedSourceFields.length === 3) {
                this.selectedSourceFields.splice(2, 1)
                this.errorMessageVisible = true
            } else {
                this.errorMessageVisible = false
            }
        },
        moveToTheRight() {
            if (this.selectedSourceFields.length === 1 || this.selectedSourceFields.length === 2) {
                const newLevel = { code: this.selectedSourceFields[0], name: this.selectedSourceFields[1] ?? this.selectedSourceFields[0], hasCopy: this.selectedSourceFields.length === 1, isLast: true } as any
                newLevel.code.level = this.dimensionDestinationFields.length + 1
                newLevel.name.level = this.dimensionDestinationFields.length + 1
                if (this.dimensionDestinationFields.length > 0) this.dimensionDestinationFields[this.dimensionDestinationFields.length - 1].isLast = false
                for (let i = 0; i < this.selectedSourceFields.length; i++) {
                    const index = this.dimensionSourceFields.findIndex((el: any) => el.ID === this.selectedSourceFields[i].ID)
                    if (index !== -1) this.dimensionSourceFields.splice(index, 1)
                }
                this.selectedSourceFields = []
                this.dimensionDestinationFields.push(newLevel)
            }
            this.$emit('levelsChanged', this.dimensionDestinationFields)
        },

        moveToTheLeft() {
            if (this.selectedDestinationFields.length === 0) return
            for (let i = 0; i < this.selectedDestinationFields.length; i++) {
                delete this.selectedDestinationFields[i].code.level
                delete this.selectedDestinationFields[i].name.maxLevel
                this.dimensionSourceFields.push(this.selectedDestinationFields[i].code)
                if (!this.selectedDestinationFields[i].hasCopy) {
                    this.dimensionSourceFields.push(this.selectedDestinationFields[i].name)
                }

                const index = this.dimensionDestinationFields.findIndex((el: any) => el.code.ID === this.selectedDestinationFields[i].code.ID)
                if (index !== -1) this.dimensionDestinationFields.splice(index, 1)
            }

            this.selectedDestinationFields = []

            for (let i = 0; i < this.dimensionDestinationFields.length; i++) {
                this.dimensionDestinationFields[i].code.level = i + 1
                this.dimensionDestinationFields[i].name.level = i + 1
            }
            this.$emit('levelsChanged', this.dimensionDestinationFields)
        },
        move(destinationField: any, index: number, direction: 'up' | 'down') {
            const tempIndex = direction === 'up' ? index - 1 : index + 1

            destinationField.code.level = tempIndex + 1
            destinationField.name.level = tempIndex + 1

            this.dimensionDestinationFields[index] = this.dimensionDestinationFields[tempIndex]
            this.dimensionDestinationFields[index].code.level = index + 1
            this.dimensionDestinationFields[index].level = index + 1
            this.dimensionDestinationFields[tempIndex] = destinationField
            this.$emit('levelsChanged', this.dimensionDestinationFields)
        },
        moveToRecursive(destinationField: any, index: number) {
            if (this.recursive) {
                this.selectedDestinationFields = [this.recursive]
                this.moveToTheLeft()
            }
            destinationField.isLast = false
            this.dimensionDestinationFields.splice(index, 1)
            if (this.dimensionDestinationFields.length > 0) {
                this.dimensionDestinationFields[this.dimensionDestinationFields.length - 1].isLast = true
            }
            this.selectedDestinationFields = []
            this.recursive = destinationField
            this.$emit('recursiveChanged', { recursive: this.recursive, recursiveParentName: this.recursiveParentName, recursiveParentDescription: this.recursiveParentDescription, levels: this.dimensionDestinationFields })
        },
        removeRecursive() {
            this.selectedDestinationFields = [this.recursive]
            this.moveToTheLeft()
            this.recursive = false
            this.recursiveParentName = null
            this.recursiveParentDescription = null
            this.$emit('recursiveChanged', null)
        }
    }
})
